import React from 'react';
import classes from './RadioButton.module.scss';
import Txt from 'components/atoms/Txt/Txt';

export interface Props {
  value: string;
  name: string;
  label: string;
  onClick?: () => void;
}

const RadioButton: React.FC<Props> = ({ name, value, label, onClick }) => {
  return (
    <label className={classes.root} onClick={onClick}>
      <input type="radio" name={name} value={value} />
      <Txt>{label}</Txt>
    </label>
  );
};

export default RadioButton;
